import { getHostname, getSiteBrand } from "@/lib/siteHosts";

/** Company / legal identity for Terms, Privacy Policy, and DPA. Brand name follows the host. */

const FALLBACK = {
  address: "8 Springdale St, Claremont Meadows, Wollongong, NSW, Australia, 2500",
  supportEmail: "support@fractolabs.com",
  governingLaw: "New South Wales, Australia",
};

/** Empty / unset / whitespace-only env → ""; otherwise trimmed value. */
export function optionalEnv(value) {
  if (typeof value !== "string") {
    return "";
  }
  return value.trim();
}

/** Parenthetical ACN/ABN clause for inline legal copy, or "" when both are empty. */
export function formatCompanyRegistrationClause(company) {
  const parts = [];
  if (company?.acn) {
    parts.push(`ACN: ${company.acn}`);
  }
  if (company?.abn) {
    parts.push(`ABN: ${company.abn}`);
  }
  return parts.length ? ` (${parts.join("; ")})` : "";
}

const COMPANY_DETAILS = {
  acn: optionalEnv(process.env.REACT_APP_COMPANY_ACN),
  abn: optionalEnv(process.env.REACT_APP_COMPANY_ABN),
  address: process.env.REACT_APP_COMPANY_ADDRESS || FALLBACK.address,
  supportEmail: process.env.REACT_APP_SUPPORT_EMAIL || FALLBACK.supportEmail,
  governingLaw: process.env.REACT_APP_GOVERNING_LAW || FALLBACK.governingLaw,
};

/** Brand and legal name follow the host. Email, address, and registration numbers stay fixed. */
export function getLegalCompany(hostname = getHostname()) {
  const brand = getSiteBrand(hostname);
  return {
    legalName: brand.legalName,
    brandName: brand.name,
    ...COMPANY_DETAILS,
  };
}

function liveCompanyField(key) {
  return {
    enumerable: true,
    get() {
      return getLegalCompany()[key];
    },
  };
}

/** Live view of getLegalCompany() so existing pages read the host brand at render time. */
export const LEGAL_COMPANY = Object.defineProperties(
  {},
  {
    legalName: liveCompanyField("legalName"),
    brandName: liveCompanyField("brandName"),
    acn: liveCompanyField("acn"),
    abn: liveCompanyField("abn"),
    address: liveCompanyField("address"),
    supportEmail: liveCompanyField("supportEmail"),
    governingLaw: liveCompanyField("governingLaw"),
  }
);
